import { Link } from "@wrstudios/components";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  ButtonLayout,
  LargeText,
  RouteContainer,
  Subscriptions as Subscription,
  Title
} from "./styled/subscriptions-route";

class UnsubscribeRoute extends Component {
  render() {
    const { hasFetched, streamName } = this.props;
    return hasFetched ? (
      <RouteContainer>
        <Title>Your Subscription</Title>
        <Subscription>
          <LargeText>
            You've successfully unsubscribed from:
            <br />
            <strong>{streamName}</strong>
          </LargeText>
          <ButtonLayout>
            <Link to="/activity">
              <button className="helix-btn helix-btn--primary helix-btn--large">
                Go to Activity
              </button>
            </Link>
          </ButtonLayout>
        </Subscription>
      </RouteContainer>
    ) : null;
  }

  componentDidMount() {
    this.props.getStreamSubscription(this.props.subscriptionId);
  }
}

UnsubscribeRoute.propTypes = {
  hasFetched: PropTypes.bool.isRequired,
  streamName: PropTypes.string,
  streamId: PropTypes.string,
  subscriptionId: PropTypes.string.isRequired,
  getStreamSubscription: PropTypes.func.isRequired
};

export default UnsubscribeRoute;
